import EVImg from '@components/EVImg';
import { AspectBox } from '@components/Layout';
import RichText from '@components/RichText';
import { TypeBlogTextAndImage } from '@contentful/types/TypeBlogTextAndImage';
import { FC } from 'react';
import { ContentContainer, GridContainer } from './styles';

export interface BlogTextAndImageProps {
  header: TypeBlogTextAndImage['fields']['header'];
  richText?: TypeBlogTextAndImage['fields']['richText'];
  imgFocalPoint: TypeBlogTextAndImage['fields']['imgFocalPoint'];
  reverse: TypeBlogTextAndImage['fields']['reverse'];
}

const BlogTextAndImage: FC<BlogTextAndImageProps> = ({
  header,
  richText,
  imgFocalPoint,
  reverse,
}) => {
  return (
    <GridContainer $reverse={reverse}>
      <ContentContainer className="blogtextandimage">
        {header && <h3>{header}</h3>}
        {richText && <RichText richText={richText} />}
      </ContentContainer>

      <AspectBox $ratio={1}>
        {imgFocalPoint && (
          <EVImg imageFocalPointData={imgFocalPoint} sizes={['100vw', '100vw', '500px']} />
        )}
      </AspectBox>
    </GridContainer>
  );
};

export default BlogTextAndImage;
